import React, { useState } from "react";
import MuiUploader from "./../components/basicComponent/MuiUploader";
import MuiButton from "./../components/basicComponent/MuiButton";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";

type GSTRow = {
  state: string;
  gst: string;
  company: string;
  email: string;
  phone: string;
  address: string;
  pincode: string;
};

const GSTDetails = () => {
  const [rows, setRows] = useState<GSTRow[]>([
    {
      state: "",
      gst: "",
      company: "",
      email: "",
      phone: "",
      address: "",
      pincode: "",
    },
  ]);

  const addRow = () => {
    setRows([
      ...rows,
      {
        state: "",
        gst: "",
        company: "",
        email: "",
        phone: "",
        address: "",
        pincode: "",
      },
    ]);
  };

  const handleChange = (index: number, field: keyof GSTRow, value: string) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 ">
              <h3 className="card-title titlecolorr">View GST Details</h3>
            </div>
            <div className="card">
              <div className="row">
                <div className="card-body">
                  <div className="col-md-12">
                    <div className="row mt-3">
                      <div className="col-md-4 mb-3">
                        <MuiSearchSelect
                          placeholder={"Business Unit"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div className="col-md-4 mb-3">
                        <MuiSearchSelect
                          label="Agent Name"
                          placeholder={"Agent Name"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                    </div>

                    <div className="user-button w-full">
                      <MuiButton
                        className="get-btn"
                        label="Submit"
                        onClick={() => {}}
                        type="submit"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fixed mb-4">
            <div className="card-header mb-1 ">
              <h3 className="card-title titlecolorr">Add GST Details</h3>
            </div>
            <div className="card">
              <div className="row">
                <div className="card-body">
                  <div className="col-md-12">
                    <div className="row mt-3">
                      <div className="col-md-4 mb-3">
                        <MuiSearchSelect
                          placeholder={"Business Unit"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div className="col-md-4 mb-3">
                        <MuiSearchSelect
                          label="Agent Name"
                          placeholder={"Agent Name"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ maxWidth: "100%", overflowX: "scroll" }}>
                <table className="table table-bordered">
                  <thead className="table-secondary text-center">
                    <tr>
                      <th>State</th>
                      <th>GST Number</th>
                      <th>Company Name</th>
                      <th>Email ID</th>
                      <th>Phone No.</th>
                      <th>Address</th>
                      <th>Pincode</th>
                      <th>Click</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, idx) => (
                      <tr key={idx}>
                        <td>
                          <select
                            className="form-select"
                            value={row.state}
                            onChange={(e) =>
                              handleChange(idx, "state", e.target.value)
                            }
                          >
                            <option value="">--Select--</option>
                            <option value="Delhi">Delhi</option>
                            <option value="Maharashtra">Maharashtra</option>
                            <option value="Karnataka">Karnataka</option>
                            {/* Add more states as needed */}
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.gst}
                            onChange={(e) =>
                              handleChange(idx, "gst", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.company}
                            onChange={(e) =>
                              handleChange(idx, "company", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="email"
                            className="form-control"
                            value={row.email}
                            onChange={(e) =>
                              handleChange(idx, "email", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="tel"
                            className="form-control"
                            value={row.phone}
                            onChange={(e) =>
                              handleChange(idx, "phone", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.address}
                            onChange={(e) =>
                              handleChange(idx, "address", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.pincode}
                            onChange={(e) =>
                              handleChange(idx, "pincode", e.target.value)
                            }
                          />
                        </td>
                        <td className="text-center">
                          <button className="btn btn-success" onClick={addRow}>
                            +
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="user-button w-full">
                <MuiButton
                  className="clear-btn"
                  onClick={() => {}}
                  label={"Clear"}
                />
                <MuiButton
                  className="get-btn"
                  label="Submit"
                  onClick={() => {}}
                  type="submit"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default GSTDetails;
